import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const HelpSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default HelpSVG;
